module.exports = __webpack_public_path__ + "static/media/bluetooth.54713832.png";